import AcceleratorDoc from "../AcceleratorDoc";
import { TableModelData } from "../TableModel";
import { RunTableReuse, RunTableReuseResponse } from "./RunTableReuse";

class TableReuseGenerator {
  docType: string;
  tableName: string;
  constructor(docType: string, tableName: string) {
    this.docType = docType;
    this.tableName = tableName;
  }

  async calculate(
    acceleratorDoc: AcceleratorDoc,
  ): Promise<TableModelData[] | undefined> {
    const response = await this.callApi(acceleratorDoc);
    if (!response) {
      //console.warn(`Error calling API to calculate reuse`);
      return undefined;
    }
    return this.getResults(response);
  }

  getResults(response: RunTableReuseResponse): TableModelData[] {
    if (!response.valid) {
      console.warn(
        `Could not calculate reuse for TABLE:${this.tableName}`,
        response!.reason,
      );
      // console.log(response!.reason);
    }
    return response.results;
  }

  async callApi(
    acceleratorDoc: AcceleratorDoc,
  ): Promise<RunTableReuseResponse | null> {
    return await new RunTableReuse(
      acceleratorDoc.classifiedDocType,
      this.tableName,
    ).calculate(acceleratorDoc);
  }
}

export { TableReuseGenerator };
